
import React, { useState } from "react"

import PopupModal from "./ModalComponent/PopupModal";
import InputComponent2 from "./InputComponent/InputComponent2";
import { getLocalStorage, userValidation } from "../Functions/Utils";
import AlertBox from "./AlertBox/AlertBox";
import { ManageApis } from "../AppServices/ManageApi";
import Loader from "./LoaderComponent/Loader";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { useStoreValues } from "../Context/storeProvider";


function HeaderSection({ handleToggleBtn, headerName,enableSideBar=true,enableProfile=true }) {
  const { user } = useStoreValues();

  const [toggled, setToggled] = useState(false);
  const [showAvatar_Popup, setShowAvatar_Popup] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setisLoading] = useState(false);
  const [changePasswordData, setChangePasswordData] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",

  });

  const toggleChnage = () => {
    setToggled(!toggled);
    handleToggleBtn(toggled)
  }

  let chnagepasswordForm = [

    {
      type: "password",
      name: "current_password",
      label: "Current Password",
      isDisabled: false,
      error: "",
      value: changePasswordData.current_password,
    },
    {
      type: "password",
      name: "new_password",
      label: "New Password",
      isDisabled: false,
      error: "",
      value: changePasswordData.new_password,
      
    },
    {
      type: "password",
      name: "confirm_password",
      label: "Confirm Password",
      isDisabled: false,
      error: "",
      value: changePasswordData.confirm_password,
    },
  ];

  const [visible, setvisible] = useState({ show: false, type: "" });
  const AlertinitialValue = {
    show: false,
    message: "",
    isfalse: false,
    isSuccess: false,
    isWarning: false,
  };
  const [showAlert, setShowAlert] = useState(AlertinitialValue);
  const navigate = useNavigate()
  const handleChange = (e, type) => {
    const { name, value } = e.target;
    // //console.log(name, value, type);

    // ""
    switch (name) {
      case "current_password":
        // ""
        setChangePasswordData((prevState) => ({
          ...prevState,
          [name]: value.slice(0, 12).replace(" ", "").trim(),
        })); //maxlength 12
        if (!value) {
          handleError("Please enter current password", name);
        }
        if (
          changePasswordData.new_password &&
          value === changePasswordData.new_password
        ) {
          handleError("current password can't be same as new password", name);
        } else {
          handleError(null, name);

          handleError(null, "new_password");
        }



        break;
      case "new_password":
        // ""
        setChangePasswordData((prevState) => ({
          ...prevState,
          new_password: value.slice(0, 12).replace(" ", "").trim(),
        })); //maxlength 12
        if (
          changePasswordData.confirm_password &&
          value !== changePasswordData.confirm_password
        ) {
          handleError("Passwords do not match", name);
        }
        else if (
          changePasswordData.current_password &&
          value === changePasswordData.current_password
        ) {
          handleError("new password can't be same as current password", name);
        }
        else {
          handleError(null, name);
          handleError(null, "confirm_password");
          handleError(null, "current_password");
        }

        break;
      case "confirm_password":
        setChangePasswordData((prevState) => ({
          ...prevState,
          [name]: value.slice(0, 15).replace(" ", "").trim(),
        })); //maxlength 12
        if (
          changePasswordData.new_password &&
          changePasswordData.new_password !== value
        ) {
          handleError("Passwords do not match", name);
        } else {
          handleError(null, name);
          handleError(null, "new_password");
        }

        break;


      default:
        break;
    }

  };
  const handleError = (error, input) => {
    setErrors((prevState) => ({ ...prevState, [input]: error }));
  };
  const handleChangePassword = async () => {

    const validate = () => {
      let isValid = true;

      let array = Object.keys(changePasswordData);
      let result = userValidation(changePasswordData, array);

      result.forEach((item) => {

        handleError(`Please fill the ${item.replace("_", " ")}`, item);
        isValid = false;

      });

      array.forEach((element) => {
        if (changePasswordData[element].length < 5) {

          handleError(`Please enter a password with a minimum of 5 characters.`, element);
          isValid = false;
        } else {
          handleError(null, element);
          isValid = true;
        }

      });

      // //console.log(result);

      Object.keys(errors).forEach((key) => {
        if (errors[key]) {
          isValid = false;
          // //console.log(errors[key]);
        }
      });

      return isValid;
    };
    try {
      if (validate()) {
        setisLoading(true);
        setvisible((pre) => ({
          show: false,
          type: "",
        }));
        const reqstBody = {
          id: getLocalStorage("clientId"),
          emailId: getLocalStorage("email"),
          currentPassword: changePasswordData.current_password,
          newPassword: changePasswordData.new_password,
          confirmNewPassword: changePasswordData.confirm_password,
        };
        let result = await ManageApis(
          "post",
          global.changePassword,
          reqstBody
        );
        if (result.message === "Success") {
          // //console.log(result);
          // if()
          // ""
          if (result?.response_data == "Password changed successfully.") {
            setChangePasswordData((pre) => ({

              confirm_password: "",
              current_password: "",
              new_password: "",
            }));
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: result.response_data,
              isSuccess: true,
            }));
            setisLoading(false);
          }
          else {
            setChangePasswordData((pre) => ({

              confirm_password: "",
              current_password: "",
              new_password: "",
            }));
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: result.response_data,
              isSuccess: false,
              isWarning: true,
            }));
            setisLoading(false);
          }
          // alert("Password changed successfully.");
        } else {
          setChangePasswordData((pre) => ({

            confirm_password: "",
            current_password: "",
            new_password: "",
          }));
          setisLoading(false);
          // //console.log(result);
          setvisible((pre) => ({
            show: false,
            type: "",
          }));
          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: result?.response_data?.title,
            isSuccess: false,
            isfalse: true,
          }));
        }
      }

    } catch (err) {
      // //console.log(err);
    }
  }
  const handleLogout = () => {
    setisLoading(true)
    localStorage.clear()
    window.location.href = '/'

  }

  return (
    <>
      {isLoading && <Loader />}
      <div className="py-1 py-md-0 d-flex justify-content-end">
        <span className=" d-md-none">{user}</span>
      </div>
      <div className=" py-2 row align-items-center" >
        <div className="col-auto col-md-4"  >
          {enableSideBar && <div className="d-flex d-lg-none round_sm  bg_master2 rounded-circle cursor-pointer" onClick={toggleChnage}>
            <i className="fas fa-bars m-auto text-white"></i>
          </div>}
        </div>
        <div className="col col-md-4">
          <h2 className="font_22 text_master2 fw-bold mb-0  text-center">{headerName}</h2>
        </div>

        <div className={`d-flex gap-3 cursor-pointer d-none`} onClick={() => setShowAvatar_Popup(!showAvatar_Popup)}>
          <div className="round_sm d-flex bg_master_gradient rounded-circle position-relative">
            <i className="fas fa-user-alt m-auto text-white"></i>
            <div className={`position-absolute header_dropdwn br_5 border bg-white ${!showAvatar_Popup ? "d-none" : ""}`}>
              <div className="d-flex flex-column text-black">
                <div className="border-bottom d-flex" onClick={() => setvisible((pre) => ({ show: true }))}>
                  <span className="px-3 ps-2 py-3 font_14 font_500  px_hover_1 cursor-pointer w-100">Change password</span>
                </div>
                <div className="border-bottom d-flex">
                  <span className="px-3 ps-2 py-3 font_14 font_500 px_hover_1 cursor-pointer w-100" onClick={handleLogout}>Log out</span>
                </div>
              </div>
            </div>
          </div>
        </div>

       { enableProfile&&<div className="col-auto col-md-4 ">
          <div className="d-flex align-items-center justify-content-end gap-2  font_500">
            <span className="d-none d-md-block">{user}</span>
            <Dropdown>
              <Dropdown.Toggle variant="unset" className="">
                <div className='bg-white p-1 rounded-pill'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                    <path d="M18 6C19.5913 6 21.1174 6.63214 22.2426 7.75736C23.3679 8.88258 24 10.4087 24 12C24 13.5913 23.3679 15.1174 22.2426 16.2426C21.1174 17.3679 19.5913 18 18 18C16.4087 18 14.8826 17.3679 13.7574 16.2426C12.6321 15.1174 12 13.5913 12 12C12 10.4087 12.6321 8.88258 13.7574 7.75736C14.8826 6.63214 16.4087 6 18 6ZM18 21C24.63 21 30 23.685 30 27V30H6V27C6 23.685 11.37 21 18 21Z" fill="#1A82E2" />
                  </svg>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="NotifMenu">
                <div className={`zi_1  br_5 border bg-white `}>
                  <div className="d-flex flex-column text-black">
                    <div className="border-bottom d-flex" onClick={() => setvisible((pre) => ({ show: true }))}>
                      <span className="px-3 ps-2 py-3 font_14 font_500  px_hover_1 cursor-pointer w-100">Change password</span>
                    </div>
                    <div className="border-bottom d-flex">
                      <span className="px-3 ps-2 py-3 font_14 font_500 px_hover_1 cursor-pointer w-100" onClick={handleLogout}>Log out</span>
                    </div>
                  </div>
                </div>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>}

        <PopupModal
          title=""
          size="md"
          visible={visible.show}
          handleClose={() => {
            setvisible((prv) => ({ show: false, type: "" })); setChangePasswordData((pre) => ({
              confirm_password: "",
              current_password: "",
              new_password: "",
            })); setErrors({})
          }}
        >
          <div className="row">
            {chnagepasswordForm.map((itm, index) => (
              <div
                key={index}
                className={`${itm.hasOwnProperty("col") ? itm.col : "col-12"}`}
              >
                <InputComponent2
                  label={itm.label}
                  name={itm.name}
                  type={itm.type}
                  maxlength={30}
                  value={changePasswordData[itm.name]}
                  error={errors[itm.name]}
                  disabled={itm.isDisabled}
                  onchange={(e) => handleChange(e, visible.type)}
                />
              </div>
            ))}

            <div className=" d-flex justify-content-end">
              <button
                className="btn btn-master px-3 font_14"
                onClick={handleChangePassword}
              >
                Submit
              </button>
            </div>
          </div>


        </PopupModal>

        <AlertBox
          show={showAlert.show}
          message={showAlert.message}
          enableFailIcon={showAlert.isfalse}
          enableSuccessIcon={showAlert.isSuccess}
          enableWarningIcon={showAlert.isWarning}
          handlecancel={() => setShowAlert(AlertinitialValue)}
        />
      </div>

    </>
  )
}

export default HeaderSection